module.exports = __webpack_public_path__ + "static/media/EnergySmartBtn.1afcbd95.svg";